import React, { useState } from 'react'
import Navigator from '../../components/common/Navigator'
import { Button } from '../../components/common'
import { useFetchEvents } from './api'
// import parse from 'html-react-parser'
import { useNavigate } from 'react-router-dom'
import DOMPurify from 'dompurify'

const Events = () => {
  const navigate = useNavigate()
  const { data, isLoading, isError } = useFetchEvents()

  // pagination states
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)

  if (isLoading) {
    return (
      <div className="text-center mt-6 text-gray-500">Loading events...</div>
    )
  }

  if (isError || !data?.data) {
    return (
      <div className="text-center mt-6 text-red-500">
        Failed to load events.
      </div>
    )
  }

  const formatDate = (dateString: any) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
  }

  // pagination logic
  const totalEvents = data.data.length
  const totalPages = Math.ceil(totalEvents / pageSize)
  const startIndex = (currentPage - 1) * pageSize
  const paginatedEvents = data.data.slice(startIndex, startIndex + pageSize)

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage)
    }
  }

  const handleChangeRowsPerPage = (newSize: number) => {
    setPageSize(newSize)
    setCurrentPage(1) // reset to first page when page size changes
  }
  const capitalizeHTMLText = (html: string) => {
    if (!html) return ''
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const capitalizeNode = (node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || ''
        node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
      } else if (node.childNodes.length > 0) {
        node.childNodes.forEach(capitalizeNode)
      }
    }

    doc.body.childNodes.forEach(capitalizeNode)
    return doc.body.innerHTML
  }

  return (
    <div className="lg:w-11/12 mx-auto py-6 font-sans">
      <div>
        <Navigator title="Upcoming Events" slug="UPCOMMINGEVENTS" />
      </div>
      <h1 className="text-3xl font-semibold text-gray-900">Upcoming Events</h1>
      <p className="text-gray-500 mt-1 mb-6">
        Explore Our Latest Events and Engagements
      </p>
      <hr className="border-t-2 border-primaryBlue " />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-16 gap-y-8 mt-6">
        {paginatedEvents.map((item: any) => (
          <div
            key={item.id}
            className="rounded-md overflow-hidden flex flex-col bg-white"
          >
            <img
              src={item.thumb}
              alt={item.title}
              className="w-full h-56 object-cover"
            />
            <div className="py-4">
              <div className="flex justify-between">
                <div>
                  <div className="text-xs text-gray-500 mb-1">
                    Posted On: {formatDate(item.event_start_date)}
                  </div>
                  <div className="text-sm text-gray-900">{item.location}</div>
                </div>
                <div>
                  {/* <span className="text-xs bg-PrimaryOrange text-white px-2 py-1 rounded-xl">
                    {item.mode}
                  </span> */}
                  <span className="text-xs bg-PrimaryOrange text-white px-2 py-1 rounded-xl">
                    {item.mode
                      ? item.mode.charAt(0).toUpperCase() + item.mode.slice(1)
                      : ''}
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-between mt-2">
                {/* <h3 className="text-xl font-medium text-black">{item.name}</h3> */}
                <h3 className="text-xl font-medium text-black">
                  {item.name
                    ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                    : ''}
                </h3>
              </div>
              <div
                className="text-sm text-gray-500 mt-2 leading-[2] line-clamp-3"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(
                    capitalizeHTMLText(item?.description || ''),
                    {
                      FORBID_ATTR: ['style'],
                    }
                  ),
                }}
              />
            </div>
            <div className="py-4 mt-auto">
              <Button
                label="View More"
                onClick={() =>
                  navigate('/initiatives/upcomming-events-detail', {
                    state: { event: item },
                  })
                }
                outlined
                className="border-1 border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 py-3 hover:bg-PrimaryOrange hover:text-white w-full"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-between px-3 pb-10 w-full">
        <div className="flex justify-center mt-4">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
          >
            <span>＜</span>
          </button>
          <button className="w-12 h-10 lg:w-16 md:w-14 flex items-center justify-center">
            <span className="p-2 border rounded">{currentPage}</span>
          </button>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="p-2 border text-black rounded mx-1 w-12 h-10 flex items-center justify-center disabled:opacity-50"
          >
            <span>＞</span>
          </button>
        </div>

        <div className="flex justify-center mt-4 mx-1">
          <select
            value={pageSize}
            onChange={(e) => handleChangeRowsPerPage(Number(e.target.value))}
            className="border p-2 rounded"
          >
            {[10, 20, 30, 50, 100, 200].map((size) => (
              <option key={size} value={size}>
                {size} cards
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default Events
